import { render } from "./DetailedSummary.vue?vue&type=template&id=4b75292c"
import script from "./DetailedSummary.vue?vue&type=script&lang=js"
export * from "./DetailedSummary.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__